import { Pipe, PipeTransform } from '@angular/core';
import { getLocation } from '../helpers/location.helper';
import { GoogleMapsService } from '../services/google-maps.service';


@Pipe({
  name: 'sortByPipe'
})
export class SortByPipePipe implements PipeTransform {

  constructor(public googleMapsService: GoogleMapsService) {}

  transform(results: Array<any>, searchType): any {
    if (searchType == 'Distance') {
      results.sort((a, b) => (a.item || a).distanceFromMe.value - (b.item || b).distanceFromMe.value);
    } else if(searchType == 'Alphabetical') {
      results.sort((a, b) => {
        if((a.item || a).name < (b.item || b).name) return -1;
        if((a.item || a).name > (b.item || b).name) return 1;
        return 0;
      });
    }
    return results;
  }

}
